import Vue from 'vue'
import * as actions from './actions'
import * as getters from './getters'
import {
  FETCH_LOCATION,
  SET_LAST_UPDATE_STATUS,
  SET_TRACKING
} from './mutation-types'

// Mutator methods
// https://vuex.vuejs.org/en/mutations.html
const mutations = {

  [SET_LAST_UPDATE_STATUS] (state, status) {
    state.lastUpdateStatus.success = status.success
  },

  [FETCH_LOCATION] (state, location) {
    let newLocation = {
      longitude: location.longitude || location.coords.longitude,
      latitude: location.latitude || location.coords.latitude,
      timestamp: new Date().getTime()
    }

    Vue.set(state, 'location', newLocation)
  },

  [SET_TRACKING] (state, isTracking) {
    Vue.set(state, 'isTracking', isTracking)
  }
}

const state = {
  location: {
    longitude: 0,
    latitude: 0,
    timestamp: 0
  },
  isTracking: false,
  lastUpdateStatus: {
    success: false,
    error: null
  }
}

export {
  state,
  actions,
  mutations,
  getters
}
